import { FileSpreadsheet, Clock } from 'lucide-react';

export default function CaGstReports() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-white">GST reports</h2>
        <p className="text-slate-400">
          GSTR-style output and input tax summaries will be available here in a future release.
        </p>
      </div>

      <div className="rounded-2xl border border-dashed border-white/15 bg-white/[0.03] p-10 text-center">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-white/5 text-slate-400">
          <FileSpreadsheet className="h-8 w-8" />
        </span>
        <h3 className="mt-4 text-lg font-semibold text-white">Coming soon</h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-slate-400">
          GST return reports (B2B, B2C, HSN summary, and tax liability) are planned for a future
          update. Revenue and expense CSV exports already include taxable line details where
          applicable.
        </p>
        <p className="mt-6 inline-flex items-center gap-2 text-xs text-slate-500">
          <Clock className="h-3.5 w-3.5" />
          Contact your hospital admin when GST reporting is enabled.
        </p>
      </div>
    </div>
  );
}
